/**
 * Normalize birthDate for the update API.
 * Preserves the existing +1-day / month-end adjustment behavior.
 */
export function normalizeBirthDateForApi(birthDate) {
  const date = new Date(birthDate);
  const lastDayOfMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0,
  ).getDate();

  if (date.getDate() === lastDayOfMonth) {
    date.setDate(1);
    date.setMonth(date.getMonth() + 1);
  } else {
    date.setDate(birthDate.getDate() + 1);
  }

  return date?.toISOString();
}
